export var NSStyles;
(function (NSStyles) {
    var TBreakPoint;
    (function (TBreakPoint) {
        TBreakPoint["mobile_sm"] = "mobile_sm";
        TBreakPoint["mobile_md"] = "mobile_md";
        TBreakPoint["mobile_lg"] = "mobile_lg";
        TBreakPoint["tablet_md"] = "tablet_md";
        TBreakPoint["tablet_lg"] = "tablet_lg";
        TBreakPoint["desktop_sm"] = "desktop_sm";
        TBreakPoint["desktop_md"] = "desktop_md";
        TBreakPoint["desktop_lg"] = "desktop_lg";
        TBreakPoint["desktop_xlg"] = "desktop_xlg";
    })(TBreakPoint = NSStyles.TBreakPoint || (NSStyles.TBreakPoint = {}));
})(NSStyles || (NSStyles = {}));
//# sourceMappingURL=breakpoints.js.map